export const TIME_UNITS = {
    DAYS: 'days',
    HOURS: 'hours',
    MILLISECONDS: 'milliseconds',
    MINUTES: 'minutes',
    MONTHS: 'months',
    SECONDS: 'seconds',
    WEEKS: 'weeks',
    YEARS: 'years'
}
